import { Grid } from '@mui/material';
import { Routes } from '@navigation/routes';
import indents from '@styles/indents.module.scss';
import { Header } from '@layouts/Base/components/Header';
import { buildRoutePath } from '@navigation/buildRoutePath';
import { usePageTitle } from '@hooks/usePageTitle';
import { Form } from '@area/users/components/UserForm/Form';
import styles from './style.module.scss';

export const NewUserPage = () => {
  usePageTitle('Новый пользователь');

  return (
    <Grid container flexDirection="column" className={styles.root} gap={indents.m}>
      <Grid item>
        <Header
          title="Новый пользователь"
          backBtnTitle="Назад к списку пользователей"
          backBtnRoute={buildRoutePath(Routes.users, { absolute: true })}
        />
      </Grid>
      <Form />
    </Grid>
  );
};
